export default "__VITE_ASSET__Bz84p5Su__"